export default "__VITE_ASSET__D3ui5dq3__"